const omniplayGameTypeToGameIdMap = {
  Loterie: 112001,
  'Book of Six': 112002,
};

export const getOmniplayCopyBetData = (ticket) => {
  const { casinoInfo } = ticket;

  const copyBetSupported = !!casinoInfo.BetMultiplyInfo.length && (
    casinoInfo.BetMultiplyInfo.every((item) => omniplayGameTypeToGameIdMap[item.GameType])
  );

  if (!copyBetSupported) return null;

  return { gameId: omniplayGameTypeToGameIdMap[casinoInfo.BetMultiplyInfo[0].GameType] };
};
